import myRequest from '@/services/myRequest';

// 敏感词类型列表
export async function querySensitiveWordTypeList(params) {
  return myRequest('get', '/sensitiveWordType/queryList', params);
}

// 新增敏感词类型
export async function addSensitiveWordType(params) {
  return myRequest('post', '/sensitiveWordType/add', params, { requestType: 'json' });
}

// 编辑敏感词类型
export async function editSensitiveWordType(params) {
  return myRequest('post', '/sensitiveWordType/edit', params, { requestType: 'json' });
}

// 删除敏感词类型
export async function deleteSensitiveWordType(params) {
  return myRequest('post', '/sensitiveWordType/delete', params);
}

